var ezdia;
(function (ezdia) {
    /**
     * This is a suporting function for genrateting unique Ids.
     * This function genrate random string of length 5 and add with other stings and return this value to makeId function.
     * Old function for this are "$.ezdia.getId" writen in ezdia.common.js
     * @param optionalIdString {string}
     */
    function getId(optionalIdString) {
        var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        var oIdString = optionalIdString ? optionalIdString + "__" : '';
        for (var i = 0; i < 5; i++) {
            randomString += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return "ez_js__" + oIdString + randomString;
    }
    /** This function overried window alert function.
     *  Old function for this are "alert" writen in common.js
     */
    function alert(title, msg) {
        $('<div></div>')
            .dialog({
            open: function (e) {
                $(e.target)
                    .closest('.ui-dialog')
                    .css('z-index', 999999999)
                    .prev('.ui-widget-overlay')
                    .css('z-index', 999999999);
            },
            buttons: [
                {
                    text: 'Close',
                    class: 'btn-link',
                    click: function () {
                        $(this).dialog('close');
                    }
                }
            ],
            close: function () {
                $(this).remove();
            },
            resizable: false,
            title: title,
            modal: true
        })
            .text(msg);
    }
    ezdia.alert = alert;
    var util;
    (function (util) {
        /**
         * Old function for this is "$.ezdia.sanitizer" writen in ezdia.common.js
         */
        util.sanitizer = {
            /**
             * This function is used to sanitizer javascript to make sure it is safe to use.
             * Old function for this is "$.ezdia.sanitizer.script" writen in ezdia.common.js
             * @param str {string}
             */
            script: function (str) {
                var reg = '<[\\s||/]*script';
                var patt = new RegExp(reg, 'ig');
                var script = patt.test(str);
                var htmlString = str;
                if (script) {
                    htmlString = this.html(str);
                }
                return htmlString;
            },
            /**
             * This function is used to sanitizer html.
             * Old function for this is "$.ezdia.sanitizer.html" writen in ezdia.common.js
             * @param str {string}
             */
            html: function (str) {
                var htmlString = str;
                if (str) {
                    htmlString = str
                        .replace(/&/g, '&amp;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#039;')
                        .replace(/’/g, '&rsquo;');
                }
                return htmlString;
            },
            /**
             * This function is used to sanitizer special charecter.
             * Old function for this is "$.ezdia.sanitizer.specialChar" writen in ezdia.common.js
             * @param str {string}
             */
            specialChar: function (str) {
                return str ? str.replace(/[^\w]/gi, '') : str;
            },
            /**
             * This function is used to sanitizer single and double quotes.
             * Old function for this is "$.ezdia.sanitizer.quotes" writen in ezdia.common.js
             * @param str {string}
             */
            quotes: function (str) {
                return str ? str.replace(/"/g, '&quot;').replace(/'/g, '&#039;') : str;
            },
            /**
             * This function is used to sanitizer html.
             * Old function for this is "$.ezdia.sanitizer.html" writen in ezdia.common.js
             * @param str {string}
             */
            style: function (str) {
                var reg = '<[\\s||/]*style';
                var patt = new RegExp(reg, 'ig');
                var style = patt.test(str);
                var htmlString = str;
                if (style) {
                    htmlString = this.html(str);
                }
                return htmlString;
            }
        };
        /**
         * This is a iterator function to genrate unique Ids
         */
        util.makeId = (function makeId() {
            var idsList = {};
            // eslint-disable-next-line func-names
            return function (optionalIdString) {
                var id = '';
                do {
                    id = getId(optionalIdString);
                } while (idsList[id]);
                idsList[id] = true;
                return id;
            };
        })();
        /**
         * This function is used for append div in end of body content, if not present in DOM for given Id.
         * Old function for this are "$.ezdia.getWrapper" writen in ezdia.common.js
         * @param id
         */
        function getWrapper(id) {
            var wrap = document.querySelector("#" + id);
            if (!wrap) {
                var wrapper = $('<div>', {
                    id: id
                });
                $('body').append(wrapper);
                wrap = document.querySelector("#" + id);
            }
            return $(wrap);
        }
        util.getWrapper = getWrapper;
        /**
         * Show alert floating banner at top right corner of page.
         * In case of success panel background color look green else red.
         * Alert panel hide itself after 5sec you can also make it manual by change settings.
         * Old function for this are "$.ezdia.showSuccessError" writen in ezdia.common.js
         * @param alertObj {ShowSuccessErrorAlertObj}
         */
        function showSuccessError(alertObj) {
            var $body = $('body');
            var template = $.ezdia.template.get('alert-welcome-task-plan-success-error');
            var content = template(alertObj);
            var autohide = alertObj.autohide === undefined ? true : alertObj.autohide;
            var alertWrap = $body.find('#ezdia-floating-alert');
            if (alertWrap.length) {
                $.ezdia.hideSuccessError(alertWrap, 0);
            }
            alertWrap = $body.append(content).find('#ezdia-floating-alert');
            setTimeout(function () {
                alertWrap
                    .css({
                    right: 30
                })
                    .find('.remove')
                    .on('click', function () {
                    $.ezdia.hideSuccessError(alertWrap);
                });
            }, 0);
            if (autohide) {
                setTimeout(function () {
                    $.ezdia.hideSuccessError(alertWrap);
                }, alertObj.duration || 5000);
            }
            return alertWrap;
        }
        util.showSuccessError = showSuccessError;
        /**
         * This function usde to hide alert show in top right corner of page.
         * Old function for this are "$.ezdia.hideSuccessError" writen in ezdia.common.js
         * @param alert {JQuery<HTMLElement>}
         * @param duration {number}
         */
        function hideSuccessError(alertWrap, duration) {
            // eslint-disable-next-line no-param-reassign
            duration = duration === 0 || duration ? duration : 500;
            alertWrap.animate({
                opacity: 0
            }, duration, 'linear', function () {
                alertWrap.remove();
            });
        }
        util.hideSuccessError = hideSuccessError;
        /**
         * This function return Tinymce editor if its in DOM else null
         * Old function for this is "getEditor" writen in commoncomponents.js
         * @param id {string}
         */
        function getEditor(id) {
            var ed = null;
            try {
                ed = tinymce.get(id);
                ed.getBody();
            }
            catch (err) {
                ed = null;
            }
            return ed;
        }
        util.getEditor = getEditor;
        /**
         * This function return all selected row ids in Ids array
         * Old function for this are "getAllItemIds" writen in common.js
         */
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        function getAllItemIds(props) {
            var _a = props || {}, url = _a.url, restProps = __rest(_a, ["url"]);
            var _b = $.ezdia.config.pageParams, account = _b.account, role = _b.role;
            var itemIds = [];
            var data = __assign({ accountName: account, roleName: role, searchString: getSearchQueryString() }, restProps);
            $.ajax({
                type: 'POST',
                url: url || 'listItemIds.htm',
                data: data,
                async: false,
                dataType: 'json',
                success: function (response) {
                    itemIds = response.split(',');
                },
                error: function () {
                    itemIds = null;
                }
            });
            return itemIds;
        }
        util.getAllItemIds = getAllItemIds;
        /**
         * This function return all selected row ids in Ids array
         * Old function for this are "$.ezdia.getSelectedGridItemsIds" writen in ezdia.common.js
         * and "getGridSelRow" writen in commoncomponents.js
         * @param gridId {string}
         */
        function getSelectedGridItemsByGridId(gridId) {
            if (gridId === void 0) { gridId = 'grid'; }
            var grid = $("#" + gridId);
            if (!grid.length) {
                return [];
            }
            var ids = grid.jqGrid('getGridParam', 'selarrrow') || [];
            if (ids.length === 0) {
                ids = grid.jqGrid('getGridParam', 'selrow');
                if (ids !== null) {
                    ids = [ids];
                }
                else {
                    ids = [];
                }
            }
            return __spread($.unique(ids));
        }
        util.getSelectedGridItemsByGridId = getSelectedGridItemsByGridId;
        /**
         * This function return select rows count of grid
         * @param gridId {string}
         */
        function getSelectedGridRowCount(gridId) {
            if (gridId === void 0) { gridId = 'grid'; }
            var selectAll = $('#selectAll').is(':checked');
            var selectedItemsLen;
            var selIds = [];
            if (selectAll) {
                selectedItemsLen = $("#" + gridId).jqGrid('getGridParam', 'records');
            }
            else {
                selIds = ezdia.util.getSelectedGridItemsByGridId(gridId);
                selectedItemsLen = selIds.length;
            }
            return selectedItemsLen;
        }
        util.getSelectedGridRowCount = getSelectedGridRowCount;
        /**
         * This function return select rows count of grid
         * @param gridId {string}
         */
        function getSelectedGridItemsIds(gridId, url) {
            if (gridId === void 0) { gridId = 'grid'; }
            var selectAll = $('#selectAll').is(':checked');
            var selIds = [];
            if (selectAll) {
                selIds = ezdia.util.getAllItemIds({ url: url });
            }
            else {
                selIds = ezdia.util.getSelectedGridItemsByGridId(gridId);
            }
            return __spread(selIds);
        }
        util.getSelectedGridItemsIds = getSelectedGridItemsIds;
        /**
         * This function is used to get signlechoice or multichoice fields option markup.
         * @param obj { column, value }
         */
        function getSelectInputOptions(obj) {
            var e_1, _a, e_2, _b;
            var column = obj.column, _c = obj.value, value = _c === void 0 ? '' : _c;
            var edittype = column.edittype, _d = column.config, config = _d === void 0 ? {} : _d;
            var optionList = '';
            if (config.options) {
                var valuesArray = [];
                if (value) {
                    valuesArray = value.split('##');
                }
                try {
                    for (var _e = __values(Object.entries(config.options)), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var _g = __read(_f.value, 2), key = _g[0], label = _g[1];
                        if (key && key.trim()) {
                            var index = valuesArray.indexOf(key);
                            var selected = '';
                            if (index !== -1) {
                                selected = "selected=\"selected\"";
                                valuesArray.splice(index, 1);
                            }
                            optionList += "<option value=\"" + key + "\" " + selected + ">" + label + "</option>";
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (valuesArray.length && edittype === 'multichoice') {
                    try {
                        for (var valuesArray_1 = __values(valuesArray), valuesArray_1_1 = valuesArray_1.next(); !valuesArray_1_1.done; valuesArray_1_1 = valuesArray_1.next()) {
                            var key = valuesArray_1_1.value;
                            optionList += "<option value=\"" + key + "\" data-other=\"other\" selected=\"selected\">" + key + "</option>";
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (valuesArray_1_1 && !valuesArray_1_1.done && (_b = valuesArray_1.return)) _b.call(valuesArray_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            return optionList;
        }
        util.getSelectInputOptions = getSelectInputOptions;
        /**
         * This function return parse json string into JSON object.
         * Old function for this is "$.ezdia.getJsonObject" writen in ezdia.common.js
         * @param jsonString {string}
         */
        function jsonParse(jsonString) {
            var obj = {};
            if (jsonString) {
                try {
                    if (typeof jsonString !== 'object') {
                        obj = JSON.parse(jsonString);
                    }
                    else {
                        obj = jsonString;
                    }
                }
                catch (err) {
                    // eslint-disable-next-line no-console
                    console.error(err);
                    obj = undefined;
                }
            }
            else {
                obj = undefined;
            }
            return obj;
        }
        util.jsonParse = jsonParse;
        /**
         * This function use to bind copy event to button
         * @param btnId {string}
         * @param inputboxId {string}
         */
        function copyBtnAction(_a) {
            var _b = _a.btnId, btnId = _b === void 0 ? 'ez-js-copy-field-btn' : _b, _c = _a.inputboxId, inputboxId = _c === void 0 ? 'ez-js-copy-field' : _c;
            var copyText = document.getElementById(inputboxId);
            $("#" + btnId).on('click', function click() {
                copyText.select();
                document.execCommand('copy');
                ezdia.util.showSuccessError({
                    message: 'Ids copied to clipboard'
                });
            });
        }
        util.copyBtnAction = copyBtnAction;
        /**
         * This function return boolean value based on condition to show column in grid.
         * True value to hide column in grid and false to show.
         * @param col: ColModel
         */
        function isGridColumnHidden(col) {
            var retVal = false;
            var GRID_COL_TYPE = ['composite', 'json', 'groupField', 'inputtab'];
            var edittype = col.edittype, config = col.config, _a = col.entity, entity = _a === void 0 ? {} : _a;
            var showEntityInGrid = false;
            var entityConfig = (entity || {}).config;
            if (entityConfig) {
                entityConfig = ezdia.util.jsonParse(entityConfig);
                showEntityInGrid = entityConfig.show_grid;
            }
            if ((col.entity && !showEntityInGrid) ||
                GRID_COL_TYPE.includes(edittype) ||
                (config && config.hideGridView)) {
                retVal = true;
            }
            return retVal;
        }
        util.isGridColumnHidden = isGridColumnHidden;
        /**
         * This method return value of url parameter you pass in this function.
         * key is parameter name is url.
         * @param key is string type
         */
        function getUrlParam(key) {
            var url = new URL(window.location.href);
            var paramValue = url.searchParams.get(key) || '';
            return paramValue;
        }
        util.getUrlParam = getUrlParam;
        /**
         * This method return value of url parameter you pass in this function.
         * key is parameter name is url.
         * @param keys is string array type
         */
        function getUrlParams(keys) {
            var e_3, _a;
            var url = new URL(window.location.href);
            var paramsArray = [];
            try {
                for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                    var key = keys_1_1.value;
                    var paramValue = url.searchParams.get(key) || '';
                    paramsArray.push(paramValue);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return paramsArray;
        }
        util.getUrlParams = getUrlParams;
        /**
         * This method return value of url parameter you pass in this function.
         * key is parameter name is url.
         * @param keys is string array type
         */
        function getUrlQueryParams(keys) {
            var e_4, _a;
            var url = new URL(window.location.href);
            var paramsArray = [];
            try {
                for (var keys_2 = __values(keys), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
                    var key = keys_2_1.value;
                    var paramValue = url.searchParams.get(key);
                    if (paramValue) {
                        paramsArray.push(key + "=" + paramValue);
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (keys_2_1 && !keys_2_1.done && (_a = keys_2.return)) _a.call(keys_2);
                }
                finally { if (e_4) throw e_4.error; }
            }
            return paramsArray.join('&');
        }
        util.getUrlQueryParams = getUrlQueryParams;
        /**
         * This method return the click on grid checkbox or not
         * @param event is string Event
         */
        function gridCBClick(event) {
            var returnVal = false;
            if (!event) {
                return returnVal;
            }
            var target = event.target;
            var $target = $(target);
            if ($target.attr('aria-describedby') === 'grid_cb' ||
                $target.parent().attr('aria-describedby') === 'grid_cb') {
                returnVal = true;
            }
            return returnVal;
        }
        util.gridCBClick = gridCBClick;
        /**
         * This function return browser name and version
         */
        function browser() {
            var userAgent = navigator.userAgent;
            var browserMatch = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            var subBrowserMatch;
            if (/trident/i.test(browserMatch[1])) {
                subBrowserMatch = /\brv[ :]+(\d+)/g.exec(userAgent);
            }
            if (browserMatch[1] === 'Chrome') {
                subBrowserMatch = userAgent.match(/\b(OPR|Edge|Edg)\/(\d+)/);
            }
            var _a = __read(subBrowserMatch || browserMatch, 3), browserName = _a[1], version = _a[2];
            return {
                version: version,
                name: browserName.toLowerCase()
            };
        }
        util.browser = browser;
        function pluralize(num, single, plural) {
            var number = num;
            if (typeof num === 'string') {
                number = parseInt(number, 10);
            }
            if (number === 1) {
                return single;
            }
            return plural;
        }
        util.pluralize = pluralize;
        /**
         * This function return all Url Params as object
         */
        function getUrlParamsAsObj() {
            var sessionDKey = ezdia.config.JS.sessionDKey;
            var _a = window.location, search = _a.search, pathname = _a.pathname;
            var page = pathname.split('/').pop();
            var _b = __read(page.split('.'), 1), pageType = _b[0];
            var data = {
                pageType: pageType
            };
            var searchParams = new URLSearchParams(search);
            var sessionKey;
            var sessiondata = {};
            searchParams.forEach(function (value, key) {
                if (sessionDKey === key) {
                    sessionKey = value;
                }
                else {
                    data[key] = value;
                }
            });
            if (sessionKey) {
                var sessionString = window.sessionStorage.getItem(sessionKey) || '';
                if (sessionString) {
                    sessiondata = ezdia.util.jsonParse(sessionString) || {};
                }
            }
            return __assign(__assign({}, data), sessiondata);
        }
        util.getUrlParamsAsObj = getUrlParamsAsObj;
        /**
         * This function is for fetch page params.
         * @param params Object
         */
        function fetchPageParams(params) {
            return __awaiter(this, void 0, void 0, function () {
                var pathname, pageType, _a, _b, data, rest, urlParams, response, error_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            pathname = window.location.pathname;
                            pageType = pathname.split('/').pop();
                            _a = params || {}, _b = _a.data, data = _b === void 0 ? {} : _b, rest = __rest(_a, ["data"]);
                            urlParams = ezdia.util.getUrlParamsAsObj();
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, ezdia.Http.post(__assign({ url: 'pageConfig.htm', data: __assign(__assign({ pageType: pageType }, urlParams), data) }, rest))];
                        case 2:
                            response = _c.sent();
                            ezdia.config.pageParams = __assign(__assign({}, ezdia.config.pageParams), response);
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _c.sent();
                            console.error(error_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/, response];
                    }
                });
            });
        }
        util.fetchPageParams = fetchPageParams;
        /**
         * Enable or Disable page loading
         */
        util.loading = new (/** @class */ (function () {
            function Loading() {
                this.ID = 'ez-js-page-loading';
                this.CLS = 'show-loading';
            }
            Loading.prototype.create = function () {
                var wrapper = document.createElement('div');
                wrapper.id = this.ID;
                wrapper.className = 'ez-loading-body';
                wrapper.innerHTML = "<span><i class=\"fa fa-spinner fa-4x fa-pulse fa-fw\"></i>";
                document.querySelector('body').appendChild(wrapper);
            };
            Loading.prototype.enable = function () {
                var id = document.getElementById(this.ID);
                if (!id) {
                    this.create();
                }
                var body = document.querySelector('body');
                body.classList.add(this.CLS);
                body.style.overflow = 'hidden';
            };
            Loading.prototype.disable = function () {
                var body = document.querySelector('body');
                body.classList.remove(this.CLS);
                body.style.overflow = '';
            };
            return Loading;
        }()))();
        function getUserSettingData(_a) {
            var action = _a.action, queryName = _a.queryName, columnValue = _a.columnValue;
            // TODO: REMOVE THIS PATCH
            var $pageParams = $.ezdia.config.pageParams;
            var epageParams = ezdia.config.pageParams;
            var pageParams = __assign(__assign({}, $pageParams), epageParams);
            var tab = pageParams.tab, _b = pageParams.account, accountName = _b === void 0 ? 'all' : _b, _c = pageParams.role, role = _c === void 0 ? 'all' : _c;
            var email = pageParams.email;
            if (!email) {
                email = ezdia.config.user.email;
            }
            // PATCH END
            var data = {
                accountName: accountName,
                role: role,
                email: email,
                action: action
            };
            if (columnValue) {
                data.columnValue = columnValue;
            }
            if (tab || queryName) {
                var queryParam = tab;
                if (tab === 'Dashboard') {
                    queryParam = queryName.substring(5);
                }
                data.tab = queryParam;
            }
            return data;
        }
        util.getUserSettingData = getUserSettingData;
        /**
         * This function is for Save user setting data.
         * @param data Object
         */
        function saveUserSettings(data) {
            return __awaiter(this, void 0, void 0, function () {
                var response, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            ezdia.util.loading.enable();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, ezdia.Http.post({
                                    url: 'saveUserSettings.htm',
                                    data: data
                                })];
                        case 2:
                            response = _a.sent();
                            ezdia.util.showSuccessError({
                                message: response.SUCCESS
                            });
                            return [3 /*break*/, 5];
                        case 3:
                            error_2 = _a.sent();
                            ezdia.util.showSuccessError({
                                message: 'Error updating data. Please try again.',
                                error: true,
                                autohide: false
                            });
                            response = error_2;
                            console.error(error_2);
                            return [3 /*break*/, 5];
                        case 4:
                            ezdia.util.loading.disable();
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/, response];
                    }
                });
            });
        }
        util.saveUserSettings = saveUserSettings;
        /**
         * This function is for Save user setting data.
         * @param data Object
         */
        function clearUserSettings(data) {
            return __awaiter(this, void 0, void 0, function () {
                var response, error_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            ezdia.util.loading.enable();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, ezdia.Http.post({
                                    url: 'clearUserSettings.htm',
                                    data: data
                                })];
                        case 2:
                            response = _a.sent();
                            ezdia.util.showSuccessError({
                                message: response.SUCCESS
                            });
                            return [3 /*break*/, 5];
                        case 3:
                            error_3 = _a.sent();
                            ezdia.util.showSuccessError({
                                message: 'Error updating data. Please try again.',
                                error: true,
                                autohide: false
                            });
                            response = error_3;
                            console.error(error_3);
                            return [3 /*break*/, 5];
                        case 4:
                            ezdia.util.loading.disable();
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/, response];
                    }
                });
            });
        }
        util.clearUserSettings = clearUserSettings;
        /**
         * This funtion is use to set page title
         * @param pageType string
         */
        function setTitle(title) {
            var _a = ezdia.config.pageParams, accountLabel = _a.accountLabel, roleLabel = _a.roleLabel;
            var titleArray = [title];
            if (accountLabel) {
                titleArray.push(accountLabel);
            }
            if (roleLabel) {
                titleArray.push(roleLabel);
            }
            document.title = titleArray.join(' - ');
        }
        util.setTitle = setTitle;
        /**
         *
         * @param len number
         */
        function getUniqueKey(len) {
            var chars = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];
            var mil = "" + new Date().getTime();
            var key = [];
            mil.split('').forEach(function (num) {
                var bol = Math.floor(Math.random() * Math.floor(2));
                var char = chars[num];
                var fchar = bol ? char.toUpperCase() : char;
                key.push(fchar);
            });
            return key.join('');
        }
        util.getUniqueKey = getUniqueKey;
        /**
         *
         * @param path
         * @param params
         * @param target
         */
        function loadUrl(path, params, target) {
            if (target === void 0) { target = '_blank'; }
            var sessionQKey = ezdia.config.JS.sessionQKey;
            var uKey = ezdia.util.getUniqueKey();
            var searchParams = new URLSearchParams(params);
            var pathQ = [];
            var sessionVal = {};
            var href = path;
            searchParams.forEach(function (value, key) {
                if (key === 'accountName' ||
                    key === 'role' ||
                    key === 'formtype' ||
                    key === 'userManagement') {
                    pathQ.push(key + "=" + value);
                }
                else {
                    sessionVal[key] = value;
                }
            });
            pathQ.push(sessionQKey + "=" + uKey);
            var querySting = pathQ.join('&');
            if (href.includes('?')) {
                href += "&" + querySting;
            }
            else {
                href += "?" + querySting;
            }
            sessionStorage.setItem(uKey, JSON.stringify(sessionVal));
            window.open(href, target);
        }
        util.loadUrl = loadUrl;
        function getSelectedIdColData(colname, gridId) {
            if (gridId === void 0) { gridId = 'grid'; }
            var _a = __read(ezdia.util.getSelectedGridItemsByGridId(gridId), 1), id = _a[0];
            var gridData = ezdia.config.GRID_DATA[gridId] || {};
            var data = gridData[id];
            var dataArray = [];
            if (data) {
                var nameArray = void 0;
                if (typeof colname === 'string') {
                    nameArray = [colname];
                }
                else {
                    nameArray = colname;
                }
                nameArray.forEach(function (qname) {
                    dataArray.push(data[qname]);
                });
            }
            return dataArray;
        }
        util.getSelectedIdColData = getSelectedIdColData;
        /**
         * This function is used to generate random hex color code
         * @returns string
         */
        function getColorCode() {
            return "#" + (0x1000000 + Math.random() * 0xffffff)
                .toString(16)
                .substr(1, 6);
        }
        util.getColorCode = getColorCode;
        /**
         * This function is used to return invert form given hex value
         * This function is used to return black or white color base of hex value
         * @param hexstr string
         * @param bw boolean
         * @returns string
         */
        function invertColor(hexstr, bw) {
            var hex = hexstr;
            if (hex.indexOf('#') === 0) {
                hex = hex.slice(1);
            }
            // convert 3-digit hex to 6-digits.
            if (hex.length === 3) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            if (hex.length !== 6) {
                throw new Error('Invalid HEX color.');
            }
            var r = parseInt(hex.slice(0, 2), 16);
            var g = parseInt(hex.slice(2, 4), 16);
            var b = parseInt(hex.slice(4, 6), 16);
            if (bw) {
                return r * 0.299 + g * 0.587 + b * 0.114 > 200 ? '#000000' : '#FFFFFF';
            }
            // invert color components
            r = (255 - r).toString(16);
            g = (255 - g).toString(16);
            b = (255 - b).toString(16);
            // pad each with zeros and return
            return "#" + padZero(r) + padZero(g) + padZero(b);
        }
        util.invertColor = invertColor;
        /**
         * helper function for invertColor
         * str: string
         * len: number
         */
        function padZero(str, len) {
            // eslint-disable-next-line no-param-reassign
            len = len || 2;
            var zeros = new Array(len).join('0');
            return (zeros + str).slice(-len);
        }
        // END
    })(util = ezdia.util || (ezdia.util = {}));
})(ezdia || (ezdia = {}));
